// extracted by mini-css-extract-plugin
export default {"DemandForm":"DemandForm_DemandForm__Nsx2O","Form":"DemandForm_Form__xtYJF"};